module.exports = __webpack_public_path__ + "static/media/ic_sensor.cefb74ff.png";